var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGifted1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "gifted-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gifted-1",
    stroke: "none",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#53FC18",
    fillRule: "nonzero",
    points: "22.34 9.5 26 4 18 4 16 7 14 4 6 4 9.66 9.5 4 9.5 4 15.1 28 15.1 28 9.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#53FC18",
    fillRule: "nonzero",
    points: "26.0799 19.0996 5.8999 19.0996 5.8999 28.4996 26.0799 28.4996"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#32970E",
    fillRule: "nonzero",
    points: "26.0799 15.0996 5.8999 15.0996 5.8999 19.0996 26.0799 19.0996"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGifted1);
export default __webpack_public_path__ + "static/media/gifted-1.75c0a047a3d0bdbffbd9aa9be1e15006.svg";
export { ForwardRef as ReactComponent };